import "./Connect.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import phone from "../../assets/phone.webp";

const Connect = ({ textData }) => {
  const lang = useContext(LangContext);

  return (
    <section className="connect">
      <div className="connect__text-container">
        <h2 className="connect__title">{textData[lang].connect.title}</h2>
        <img
          src={phone}
          className="connect__phone connect__phone_mobile"
          alt="Totem app"
        />
        <p className="connect__subtitle">{textData[lang].connect.paragraph}</p>
        <div className="connect__gradient" />
      </div>
      <img
        src={phone}
        className="connect__phone connect__phone_desktop"
        alt="Totem app"
      />
    </section>
  );
};

export default Connect;
